// extracted by mini-css-extract-plugin
module.exports = {"Modal":"Modal_Modal_Modal__mytwT","Body":"Modal_Modal_Body__yF1ti","Image":"Modal_Modal_Image__T_XYu"};